class CustomPropertyRepository {
  store
  constructor() {
    this.store = new Map();
  }

  has(property) {
    return this.store.has(property.name);
  }

  get(name) {
    return this.store.get(name);
  }

  set(property) {
    this.store.set(property.name, property);
  }

  setIfNotExists(property) {
    if (this.has(property)) {
      return;
    }
    this.set(property);
  }

  clear() {
    this.store.clear();
  }

  get items() {
    return Array.from(this.store.values());
  }
}

export default new CustomPropertyRepository();
